import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';
import NoticeBoard from './NoticeBoard';

const NoticeBoardParent = ({ apiUrl, title }) => {
    const [response, request] = useApi(apiUrl);
    const [notices, setNotices] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setNotices(response.data);
        }

    }, [response]);

    return (
        <div>
            <NoticeBoard title={title} notices={notices} />
        </div>
    );
}

export default NoticeBoardParent;